<div class="module contact-module">
    <div class="module-title">
        <div class="container">
            <h2 class="wow slideInDown" data-wow-delay="0.2s" *ngIf="data.mostrar_titulo">{{data.titulo}}</h2>
            <h3 class="wow slideInUp" data-wow-delay="0.4s" *ngIf="data.mostrar_subtitulo">{{data.subtitulo}}</h3>
        </div>
    </div>
    <div class="module-content">
        <div class="container">
            <form class="form-custom wow fadeIn" data-wow-delay="0.4s" (submit)="send()">
                <div class="form-group">
                    <label>Nome:</label> 
                    <input type="text" [(ngModel)]="dataItem.nome" name="nome" />
                </div>   
                <div class="form-group">
                    <label>E-mail:</label> 
                    <input type="text" [(ngModel)]="dataItem.email" name="email" placeholder="nome@provedor.com" />
                </div>
                <div class="form-group">
                    <label>Telefone:</label> 
                    <input type="text" [(ngModel)]="dataItem.telefone" name="telefone" placeholder="(**) *****-****" mask="(99) 99999-9999" />
                </div> 
                <div class="form-group">
                    <label>Mensagem:</label> 
                    <textarea [(ngModel)]="dataItem.mensagem" name="mensagem" rows="5"></textarea>
                </div> 
                <div class="form-group">
                    <button type="submit">
                        <i class="material-icons">send</i>
                        <span>Enviar</span>
                    </button>
                </div>   
            </form>  
        </div>    
    </div>    
</div> 
<loader [hidden]="!loader"></loader> 